import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['VoltageLevel'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getVoltageLevelById: build.query<GetVoltageLevelByIdApiResponse, GetVoltageLevelByIdApiArg>({
        query: (queryArg) => ({ url: `/VoltageLevel/${queryArg}` }),
        providesTags: ['VoltageLevel'],
      }),
      deleteVoltageLevelById: build.mutation<DeleteVoltageLevelByIdApiResponse, DeleteVoltageLevelByIdApiArg>({
        query: (queryArg) => ({ url: `/VoltageLevel/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['VoltageLevel'],
      }),
      getVoltageLevelGetByMeasurementDevice: build.query<
        GetVoltageLevelGetByMeasurementDeviceApiResponse,
        GetVoltageLevelGetByMeasurementDeviceApiArg
      >({
        query: (queryArg) => ({
          url: `/VoltageLevel/get-by-measurement-device`,
          params: {
            measurementDeviceId: queryArg,
          },
        }),
        providesTags: ['VoltageLevel'],
      }),
      getVoltageLevelGetAll: build.query<GetVoltageLevelGetAllApiResponse, GetVoltageLevelGetAllApiArg>({
        query: () => ({ url: `/VoltageLevel/get-all` }),
        providesTags: ['VoltageLevel'],
      }),
      getVoltageLevelByIdHasData: build.query<GetVoltageLevelByIdHasDataApiResponse, GetVoltageLevelByIdHasDataApiArg>({
        query: (queryArg) => ({ url: `/VoltageLevel/${queryArg}/has-data` }),
        providesTags: ['VoltageLevel'],
      }),
      getVoltageLevelByIdIsReferenced: build.query<
        GetVoltageLevelByIdIsReferencedApiResponse,
        GetVoltageLevelByIdIsReferencedApiArg
      >({
        query: (queryArg) => ({ url: `/VoltageLevel/${queryArg}/is-referenced` }),
        providesTags: ['VoltageLevel'],
      }),
      postVoltageLevel: build.mutation<PostVoltageLevelApiResponse, PostVoltageLevelApiArg>({
        query: (queryArg) => ({ url: `/VoltageLevel`, method: 'POST', body: queryArg }),
        invalidatesTags: ['VoltageLevel'],
      }),
      putVoltageLevel: build.mutation<PutVoltageLevelApiResponse, PutVoltageLevelApiArg>({
        query: (queryArg) => ({ url: `/VoltageLevel`, method: 'PUT', body: queryArg }),
        invalidatesTags: ['VoltageLevel'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as voltageLevelApi };
export type GetVoltageLevelByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoVoltageLevelExternalDto;
export type GetVoltageLevelByIdApiArg = number;
export type DeleteVoltageLevelByIdApiResponse = unknown;
export type DeleteVoltageLevelByIdApiArg = number;
export type GetVoltageLevelGetByMeasurementDeviceApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoVoltageLevelExternalDto;
export type GetVoltageLevelGetByMeasurementDeviceApiArg = number | undefined;
export type GetVoltageLevelGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoVoltageLevelExternalDto;
export type GetVoltageLevelGetAllApiArg = void;
export type GetVoltageLevelByIdHasDataApiResponse = /** status 200 OK */ boolean;
export type GetVoltageLevelByIdHasDataApiArg = /** Voltage level ID */ number;
export type GetVoltageLevelByIdIsReferencedApiResponse = /** status 200 OK */ boolean;
export type GetVoltageLevelByIdIsReferencedApiArg = /** Voltage level ID */ number;
export type PostVoltageLevelApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoVoltageLevelExternalDto;
export type PostVoltageLevelApiArg = ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoVoltageLevelExternalDto;
export type PutVoltageLevelApiResponse = unknown;
export type PutVoltageLevelApiArg = ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoVoltageLevelExternalDto;
export type ApiCommonExternalDtoVoltageLevelExternalDto = {
  id?: number;
  tsoId?: number;
  name: string;
  valueInKilovolt: number;
  comment: string;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoVoltageLevelExternalDto = {
  externalDto?: ApiCommonExternalDtoVoltageLevelExternalDto;
  externalDtos?: ApiCommonExternalDtoVoltageLevelExternalDto[] | null;
};
export type ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoVoltageLevelExternalDto = {
  externalDto?: ApiCommonExternalDtoVoltageLevelExternalDto;
};
export const {
  useGetVoltageLevelByIdQuery,
  useLazyGetVoltageLevelByIdQuery,
  useDeleteVoltageLevelByIdMutation,
  useGetVoltageLevelGetByMeasurementDeviceQuery,
  useLazyGetVoltageLevelGetByMeasurementDeviceQuery,
  useGetVoltageLevelGetAllQuery,
  useLazyGetVoltageLevelGetAllQuery,
  useGetVoltageLevelByIdHasDataQuery,
  useLazyGetVoltageLevelByIdHasDataQuery,
  useGetVoltageLevelByIdIsReferencedQuery,
  useLazyGetVoltageLevelByIdIsReferencedQuery,
  usePostVoltageLevelMutation,
  usePutVoltageLevelMutation,
} = injectedRtkApi;
